module.exports = __webpack_public_path__ + "static/media/uber_logo.7d344590.svg";